import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../components/common/Logo';
import Button from '../../components/common/Button';
import Icon from '../../components/common/Icon';
import geminiLogo from '../../Gemini_Generated_Image_rvsyaprvsyaprvsy.png';

const Landing = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      title: 'Order Form',
      subtitle: 'Submit new order',
      emoji: '📋',
      color: 'var(--accent)',
      lightColor: 'var(--accent-light)',
      action: () => navigate('/order'),
    },
    {
      title: 'Refund Form',
      subtitle: 'Claim your money',
      emoji: '💰',
      color: 'var(--orange)',
      lightColor: 'var(--orange-light)',
      action: () => navigate('/refund'),
    },
    {
      title: 'Buyer Login',
      subtitle: 'View your orders',
      emoji: '👤',
      color: 'var(--primary)',
      lightColor: 'var(--primary-light)',
      action: () => navigate('/login?role=buyer'),
    },
    {
      title: 'Track Order',
      subtitle: 'Check status',
      emoji: '🔍',
      color: 'var(--teal)',
      lightColor: 'var(--teal-light)',
      action: () => navigate('/track'),
    },
  ];

  return (
    <div 
      className="landing-container"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: 'linear-gradient(150deg, #F0FDF4 0%, #EEF2FF 60%, #F4F6F9 100%)'
      }}
    >
      {/* Background decorations */}
      <div 
        style={{
          position: 'fixed',
          top: '0',
          right: '0',
          width: '320px',
          height: '320px',
          borderRadius: '50%',
          opacity: '0.3',
          pointerEvents: 'none',
          background: 'radial-gradient(rgba(22, 163, 74, 0.1), transparent)',
          transform: 'translate(50%, -50%)'
        }}
      />
      <div 
        style={{
          position: 'fixed',
          bottom: '0',
          left: '0',
          width: '256px',
          height: '256px',
          borderRadius: '50%',
          opacity: '0.3',
          pointerEvents: 'none',
          background: 'radial-gradient(rgba(91, 91, 214, 0.08), transparent)',
          transform: 'translate(-50%, 50%)'
        }}
      />

      <div style={{ width: '100%', maxWidth: '448px', position: 'relative', zIndex: '10' }}>
        {/* Logo and Title */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
            <img 
                src={geminiLogo}
                alt="ZMA Online Logo"
                style={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '12px',
                  boxShadow: '0 10px 28px var(--primary-glow)'
                }}
              />
          </div>
          <h1 
            className="outfit"
            style={{ 
              fontWeight: '800', 
              fontSize: '36px', 
              marginBottom: '8px',
              color: 'var(--text)'
            }}
          >
            ZMA<span style={{ color: 'var(--primary)' }}>Online</span>
          </h1>
          <p 
            style={{ 
              fontSize: '14px',
              fontWeight: '500',
              color: 'var(--text-muted)'
            }}
          >
            Amazon & Flipkart Review Platform
          </p>
        </div>

        {/* Main Card */}
        <div 
          style={{
            background: 'var(--bg-card)',
            borderRadius: '24px',
            padding: '24px',
            boxShadow: 'var(--shadow-lg)',
            border: `1px solid var(--border)`
          }}
        >
          {/* Quick Actions Grid */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: '1fr 1fr', 
            gap: '12px', 
            marginBottom: '16px' 
          }}>
            {quickActions.map((action) => (
              <button
                key={action.title}
                onClick={action.action}
                style={{
                  padding: '16px',
                  borderRadius: '12px',
                  border: `2px solid ${action.color}33`,
                  background: action.lightColor,
                  transition: 'all 0.2s',
                  cursor: 'pointer',
                  textAlign: 'left'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={{ fontSize: '24px', marginBottom: '8px', textAlign: 'center' }}>{action.emoji}</div>
                <div 
                  className="outfit"
                  style={{ 
                    fontWeight: '700', 
                    fontSize: '12px', 
                    textAlign: 'center',
                    color: 'var(--text)'
                  }}
                >
                  {action.title}
                </div>
                <div 
                  style={{ 
                    fontSize: '12px', 
                    textAlign: 'center', 
                    marginTop: '4px',
                    color: 'var(--text-muted)'
                  }}
                >
                  {action.subtitle}
                </div>
              </button>
            ))}
          </div>

          {/* Mediator Login Button */}
          <Button
            variant="primary"
            size="md"
            onClick={() => navigate('/login?role=mediator')}
            style={{ width: '100%', justifyContent: 'center', marginBottom: '12px' }}
            icon="usr"
          >
            Mediator Login
          </Button>

          {/* Support / Contact Us Button */}
            <Button
                variant="secondary"
                size="md"
                onClick={() => {
                    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

                    if (isMobile) {
                        // Opens default mail app (Gmail app on most phones)
                        window.location.href = 'mailto:zmaonlinemarketing@gmail.com?subject=Support Request&body=Hello ZMA Support team,';
                    } else {
                        // Opens Gmail in browser
                        window.open(
                            'https://mail.google.com/mail/?view=cm&fs=1&to=zmaonlinemarketing@gmail.com&su=Support%20Request&body=Hello%20ZMA%20Support%20team,',
                            '_blank'
                        );
                    }
                }}
                style={{
                    width: '100%',
                    justifyContent: 'center',
                    marginBottom: '12px',
                    borderColor: 'var(--primary)',
                    color: 'var(--primary)'
                }}
                icon="mail"
            >
                Contact Us / Support
            </Button>

          <Button
            variant="secondary"
            size="md"
            onClick={() => navigate('/guides')}
            style={{
              width: '100%',
              justifyContent: 'center',
              marginBottom: '12px'
            }}
            icon="info"
          >
            View Demo Screenshots
          </Button>

          {/* Active Deals Button */}
          {/* <Button
            variant="secondary"
            size="md"
            onClick={() => navigate('/deals')}
            style={{ width: '100%', justifyContent: 'center', marginBottom: '12px' }}
            icon="deals"
          >
            Active Deals
          </Button> */}

          {/* Admin & Seller Links */}
          <div style={{ 
            paddingTop: '16px', 
            borderTop: `1px solid var(--border)` 
          }}>
            <button
              onClick={() => navigate('/admin-login')}
              style={{
                width: '100%',
                textAlign: 'center',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'colors 0.2s',
                color: 'var(--text-muted)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                marginBottom: '8px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = 'var(--accent)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'var(--text-muted)';
              }}
            >
              Admin Panel →
            </button>
            
            {/* <button
              onClick={() => navigate('/seller-login')}
              style={{
                width: '100%',
                textAlign: 'center',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'colors 0.2s',
                color: 'var(--text-muted)',
                background: 'none',
                border: 'none',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = 'var(--orange)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = 'var(--text-muted)';
              }}
            >
              Seller Portal →
            </button> */}
          </div>
        </div>

        {/* Footer */}
        <div style={{ textAlign: 'center', marginTop: '32px' }}>
          <p 
            style={{ 
              fontSize: '12px',
              color: 'var(--text-muted)'
            }}
          >
            © 2024 ZMA Online. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Landing;
